export enum GtProducts {
  // requires entry in IQServiceProvider table
  SERVICE_PROVIDER_ROLE = 1000,
  // requires entry in IQSupervisor table
  ADMINISTRATOR_ROLE = 1010,
  // requires entry in IQSkill
  ATTENDANT_ROLE = 1020,
  // requires entry in IQAgent
  CUSTOMER_CARE_ROLE = 1030,
  // requires entry in TrunkProvider
  TRUNK_PROVIDER_ROLE = 1040,
  // requires entry in VPNServiceprovider
  VPN_SERVICE_PROVIDER_ROLE = 2000,
  // requires entry in VPNSupervisor
  VPN_ADMINISTRATOR_ROLE = 2010,
  // requires entry in EndUser
  VPN_END_USER_ROLE = 2020,

  // requires entry in EndUserAccess in- or outbound
  TRIGGERING_PRODUCT = 2100,
  // requires entry in EndUserAccess both in- and outbound
  TRIGGERING_FULL_PRODUCT = 2101,
  // requires entry in EndUserAccess inbound
  TRIGGERING_INBOUND_PRODUCT = 2102,
  // requires entry in EndUserAccess outbound
  TRIGGERING_OUTBOUND_PRODUCT = 2103,

  // requires BCTExternal != 0 in DepNameValue
  BCT_EXTERNAL_PRODUCT = 2200,
  // requires CCTExternal != 0 in DepNameValue
  CCT_EXTERNAL_PRODUCT = 2201,

  // requires SWB_ACCESS = 1 in EUNameValue OR productProfile = MPBX in EUNameValue or productProfile = MPBX in DepNameValue
  SWB_PRODUCT = 3000,
  // requires SWB_ADM = 1 in EUNameValue
  SWB_ADMINISTRATOR_PRODUCT = 3001,
  // requires SWB_EXC = 1 in DepNameValue
  SWB_EXCHANGE_PRODUCT = 3002,
  // requires SWB_CRM = 1 in DepNameValue
  SWB_A_NUMBER_LOG_PRODUCT = 3003,
  // requires NumberLookup = 1 in DepNameValue
  SWB_CALLBACK_NOTIFICATION_SMS_PRODUCT = 3004,
  // requires CallbackNotificationSms = 1 in DepNameValue
  // requires SWB_DIRECTORY = 1 in DepNameValue
  SWB_DIRECTORY_PRODUCT = 3005,
  // requires SWB_STATUS_SYNC = 1 in DepNameValue
  SWB_STATUS_SYNC = 7000,

  NUMBER_LOOKUP_PRODUCT = 3100,
  // requires WallboardService = 1 in DepNameValue
  WALLBOARD_PRODUCT = 3200,
  // requires AbsentService = 1 in EUNameValue
  ABSENCE_PRODUCT = 4000,
  // requires ConferenceService = 1 in EUNameValue OR ConferenceService = 1 in DepNameValue
  CONFERENCE_PRODUCT = 5000,
  // requires ConferencePermanentService = 1 in EUNameValue OR ConferencePermanentService = 1 in DepNameValue
  CONFERENCE_FIXED_PRODUCT = 5001,
  // requires ConferenceServiceOutbound = 1 in EUNameValue OR ConferenceServiceOutbound = 1 in DepNameValue
  CONFERENCE_OUTBOUND_PRODUCT = 5002,
  // requires VoipService = 1 in EUNameValue
  VOIP_PRODUCT = 6000,

  WEBRTC_PRODUCT = 6100
}
